module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_13.4e12c6ce.jpg";